/**
 * @license
 * Copyright 2026 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
// Generated stylesheet for ./tokens/versions/v0_192/lib.test.css.
import {css} from 'lit';
export const styles = css`
`;
export default styles.styleSheet!;
